/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo } from 'react';
import { LeftTableItem } from './LeftTableItem';
import { useSelector } from 'react-redux';

import * as S from './TableRow.styled';

const formatCurrencyMetric = (value, fractionDigits) => {
  if (!value) return '0';

  return `$${Number(value).toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
};

export const TableRow = ({
  item,
  isGrouping,
  currentRequestType$,
  TABLE_ROW_HEIGHT,
  hideInstallsColumn,
}) => {
  const DynamicLeftComponent = LeftTableItem[currentRequestType$.value];
  const DynamicLeftComponentSub = LeftTableItem.sub_element;
  const [isOpen, setIsOpen] = useState(false);
  const tableSorting = useSelector((state) => state.publisherReportsFiltersTable.tableSorting);

  useEffect(() => {
    setIsOpen(false);
  }, [tableSorting?.key, tableSorting?.direction, isGrouping]);

  const sortedSubElements = useMemo(() => {
    let sortableItems = item?.subElements ? [...item.subElements] : [];
    if (tableSorting !== null) {
      sortableItems.sort((a, b) => {
        if (a[tableSorting.key] < b[tableSorting.key]) {
          return tableSorting.direction === 'ascending' ? -1 : 1;
        }
        if (a[tableSorting.key] > b[tableSorting.key]) {
          return tableSorting.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [tableSorting?.direction, tableSorting?.key, item?.subElements]);

  return (
    <>
      <S.BodyTableRow
        height={TABLE_ROW_HEIGHT}
        onClick={(event) => {
          if (event.target.className.baseVal === 'copyIcon') return;
          if (isGrouping) setIsOpen((state) => !state);
        }}
        style={
          isGrouping && !!item.subElements?.length ? { cursor: 'pointer' } : { cursor: 'auto' }
        }
      >
        <DynamicLeftComponent
          item={item}
          isGrouping={isGrouping}
          isOpen={isOpen}
          TABLE_ROW_HEIGHT={TABLE_ROW_HEIGHT}
        />
        <S.TableData>{item.impressions.toLocaleString()}</S.TableData>
        <S.TableData>{item.clicks.toLocaleString()}</S.TableData>
        {!hideInstallsColumn && <S.TableData>{item.installs.toLocaleString()}</S.TableData>}
        <S.TableData>{item.ctr1.toLocaleString()}%</S.TableData>
        <S.TableData>{formatCurrencyMetric(item.earning, 2)}</S.TableData>
        <S.TableData>{formatCurrencyMetric(item.eCPM1, 3)}</S.TableData>
        {/* empty col to fill the rest of space */}
        <S.TableData />
      </S.BodyTableRow>
      {isOpen &&
        !!item.subElements?.length &&
        isGrouping &&
        sortedSubElements.map((subItem, ind) => {
          return (
            <S.BodyTableRow
              key={ind}
              height={TABLE_ROW_HEIGHT}
              style={isGrouping ? { cursor: 'pointer' } : { cursor: 'auto' }}
            >
              <DynamicLeftComponentSub
                item={subItem}
                type={isGrouping}
                TABLE_ROW_HEIGHT={TABLE_ROW_HEIGHT}
              />
              <S.TableData>{subItem.impressions.toLocaleString()}</S.TableData>
              <S.TableData>{subItem.clicks.toLocaleString()}</S.TableData>
              {!hideInstallsColumn && (
                <S.TableData>{subItem.installs.toLocaleString()}</S.TableData>
              )}
              <S.TableData>{subItem.ctr1.toLocaleString()}%</S.TableData>
              <S.TableData>{formatCurrencyMetric(subItem.earning, 2)}</S.TableData>
              <S.TableData>{formatCurrencyMetric(subItem.eCPM1, 3)}</S.TableData>
              {/* empty col to fill the rest of space */}
              <S.TableData />
            </S.BodyTableRow>
          );
        })}
    </>
  );
};
